
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/guides/testing",
      function () {
        return require("private-next-pages/material-ui/guides/testing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/guides/testing"])
      });
    }
  